import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    const isAuthCall = original?.url?.includes("/auth/login") || original?.url?.includes("/auth/refresh");
    if (error.response?.status === 401 && original && !original._retried && !isAuthCall) {
      original._retried = true;
      try {
        await api.post("/auth/refresh");
        return api(original);
      } catch {
        // refresh fallito: la guardia delle rotte riporterà al login
      }
    }
    return Promise.reject(error);
  }
);

export function trackEvent(event) {
  try {
    if (sessionStorage.getItem("trk_" + event)) return;
    sessionStorage.setItem("trk_" + event, "1");
    api.post("/analytics/track", { event, referrer: document.referrer || "" }).catch(() => {});
  } catch {}
}

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Errore / Error";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (typeof detail?.msg === "string") return detail.msg;
  return String(detail);
}

export function fileUrl(path) {
  return `${process.env.REACT_APP_BACKEND_URL}/api/files/${path}`;
}

export default api;
